import React, { useEffect, useState } from "react";
import { Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import TransactionService from "../../../servics/notification/transaction/TransactionService";
import { formatAmount } from "../../../constants/marketplaceCheckout";
import useCurrency from "../../../hooks/useCurrency";

const EMPTY_SUMMARY = { publishedProducts: 0, receivedOrders: 0, receivedPayments: [] };

const plural = (count, singular, pluralForm) => `${count} ${count > 1 ? pluralForm : singular}`;

const PersonalHero = () => {

    const tenantUser = useSelector((state) => state.tenantUser.tenantUser);
    const tenant = useSelector((state) => state.tenant.company);
    const { currency } = useCurrency();

    // null : chargement en cours (affiché « … ») ; en cas d'échec, les compteurs restent à 0.
    const [summary, setSummary] = useState(null);

    // Le vendeur est identifié par le JWT : l'appel ne dépend pas du profil chargé en store.
    useEffect(() => {
        let cancelled = false;
        TransactionService.getSellerSummary()
            .then((data) => { if (!cancelled) setSummary(data ?? EMPTY_SUMMARY); })
            .catch((error) => {
                console.warn("Indicateurs vendeur indisponibles", error);
                if (!cancelled) setSummary(EMPTY_SUMMARY);
            });
        return () => { cancelled = true; };
    }, [tenantUser?.id]);

    const payments = summary?.receivedPayments ?? [];
    const paymentsLabel = !summary
        ? "…"
        : payments.length === 0
            ? formatAmount(0, currency)
            : payments.map(({ amount, currency }) => formatAmount(amount, currency)).join(" · ");
    const productsCount = summary?.publishedProducts ?? 0;
    const ordersCount = summary?.receivedOrders ?? 0;

    return (
        <div style={{
            background: "linear-gradient(135deg, #1FAF7A, #1E88E5)",
            borderRadius: 20,
            padding: 24,
            color: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap"
        }}>

            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                <Avatar size={64} icon={<UserOutlined />} />

                <div>
                    <h2>
                        Bonjour {tenantUser?.email || "Utilisateur"} 👋
                    </h2>

                    <p style={{ margin: 0 }}>
                        Voici vos activités aujourd’hui de{" "}
                        <b>{tenant?.companyName || "..."}</b>
                    </p>
                </div>
            </div>

            <div style={{ display: "flex", gap: 20, flexWrap: "wrap", marginTop: 10 }}>
                <div title="Paiements reçus">💰 <b>{paymentsLabel}</b></div>
                <div title="Produits mis en ligne">
                    🌽 <b>{summary ? plural(productsCount, "produit en ligne", "produits en ligne") : "…"}</b>
                </div>
                <div title="Commandes reçues">
                    📦 <b>{summary ? plural(ordersCount, "commande reçue", "commandes reçues") : "…"}</b>
                </div>
            </div>

        </div>
    );
};

export default PersonalHero;
